document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (button && nav) button.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  const mainImage = document.querySelector('[data-product-main-image]');
  document.querySelectorAll('[data-product-thumbnail]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.alt = thumbnail.dataset.imageAlt || '';
      document.querySelectorAll('[data-product-thumbnail]').forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-current', 'false');
      });
      thumbnail.classList.add('is-active');
      thumbnail.setAttribute('aria-current', 'true');
    });
  });
});
